import type { MembershipEvent } from '../../api/payment/membership.api';

/** Số id gần nhất giữ lại để bỏ trùng; overlay để mở cả buổi live không phình bộ nhớ mãi. */
export const MAX_SEEN_IDS = 500;

/** Hàng đợi thông báo hội viên mới: bỏ trùng theo joinId (đẩy realtime và lấy bù khi nối lại có thể trùng). */
export class MemberAlertQueue {
  private items: MembershipEvent[] = [];

  /** Set giữ thứ tự thêm vào: phần tử đầu là id cũ nhất, bị bỏ trước khi vượt trần. */
  private seen = new Set<string>();

  private readonly maxSeen: number;

  constructor(maxSeen = MAX_SEEN_IDS) {
    this.maxSeen = maxSeen;
  }

  get size() {
    return this.items.length;
  }

  push(ev: MembershipEvent): boolean {
    if (!ev.joinId || this.seen.has(ev.joinId)) return false;
    this.seen.add(ev.joinId);
    while (this.seen.size > this.maxSeen) {
      const oldest = this.seen.values().next().value as string;
      this.seen.delete(oldest);
    }
    this.items.push(ev);
    return true;
  }

  shift(): MembershipEvent | undefined {
    return this.items.shift();
  }
}
